const colors = {
	// General
	whiteColor: '#FFFFFF',
	blackColor: '#000000',
	grayColor: '#AAAAAA',

	// Point
	activeRed: '#FF0000',
	activeBlue: '#0078FF',
	activeSkyBlue: '#54A9FF',
	activeGreen: '#3BB273',
	activeRedOrange: '#FF5700',
	activeOrange: '#FF5300',
	activePink: '#F346F2',
	activeYellow: '#FEEA00',

	// Icon
	grayIconColor: '#919191',

	// Font
	grayFontColor: '#7B7B80',
	lightGrayFontColor: '#B3B3B3',
	ultraLightGrayFontColor: '#D1D1D1',
	deepGrayFontColor: '#6E6E6E',

	// Border
	lightGrayBorder: '#E5E5E5',
	ultraLightGrayBorder: '#F3F3F3',
	brightGrayBorderColor: '#E8E8E8',

	// Background
	lightGrayHoverColor: '#F9F9F9',
	grayBgColor: '#CFCFCF',
	darkGrayBgColor: '#333333'
} as const;

const typography = {
	h1: { fontSize: '36px', lineHeight: '52px' },
	h2: { fontSize: '24px', lineHeight: '32px' },
	h3: { fontSize: '20px', lineHeight: '28px' },
	body1: { fontSize: '18px', lineHeight: '26px' },
	subTitle: { fontSize: '16px', lineHeight: '24px' },
	label: { fontSize: '15px', lineHeight: '22px' },
	body2: { fontSize: '14px', lineHeight: '22px' },
	caption: { fontSize: '12px', lineHeight: '18px' },
	bodyMobile: {
		// Body Mobile
		fontSize: '14px',
		lineHeight: '22px'
	}
} as const;

export type ColorsTypes = typeof colors;
export type TypographyTypes = typeof typography;

const theme = {
	colors,
	typography
} as const;

export default theme;
